// Tipos unificados para la comunicación SignalR.
// El backend envía un único "BackendMessage" con un campo `type` que indica qué tipo de mensaje es. Cada componente filtra por `type`.

export enum BackendMessageType {
  ProgressUpdate = 'progressUpdate',
  Notification = 'notification',
  RefreshData = 'refreshData',
  PermissionsChanged = 'permissionsChanged',
}

export type BackendMessage = {
  type: BackendMessageType.ProgressUpdate;
  data: JobProgressData;
  timestamp?: string;
} | {
  type: BackendMessageType.Notification;
  data: NotificationData;
  timestamp?: string;
} | {
  type: BackendMessageType.RefreshData;
  data: RefreshData;
  timestamp?: string;
} | {
  type: BackendMessageType.PermissionsChanged;
  data: PermissionsChangedData;
  timestamp?: string;
};

export interface JobProgressData {
  jobId: string;
  progress: number;
  currentValue: number;
  totalValue: number;
  finished: boolean;
  hasError?: boolean | null;
  statusMessage?: string | null;
  preInvoicingStateId?: number | null;
  alerts?: Array<{ alertType: number; message: string }> | null;
  lastUpdatedUtc?: string;
  [key: string]: any;
}

export interface NotificationData {
  type: 'info' | 'success' | 'warning' | 'error';
  title: string;
  message: string;
  userId?: number;
}

export interface RefreshData {
  entity: string;
  recordId?: number;
}

export interface PermissionsChangedData {
  userId: number;
}
